//redux
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import type { RootState, AppDispatch } from "../redux/store";
const useRedux = () => {
  const dispatch: AppDispatch = useDispatch();
  const useAppSelector = <T>(selector: (state: RootState) => T): T =>
    useSelector(selector, shallowEqual);
  return { dispatch, useAppSelector };
};

export { useRedux };
